import { Row, Column } from '@ard-online/component-styleguide';
import React from 'react';

export default function RadioChannelsSection() {
  return (
    <section id="radio-channels">
      <Row>
        <Column>
          <h2>Radio</h2>
          <p>Die ARD bietet Ihnen mit über 60 <a href="https://www.ardaudiothek.de/sender">Radiowellen</a> ein vielfältiges Hörfunkprogramm, das von den regionalen Landesrundfunkanstalten produziert wird.</p>
          <p>Für mehr Informationen zu unserem Hörfunkportfolio kontaktieren Sie uns gerne!</p>
        </Column>
      </Row>
    </section>
  );
}